import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { t, statusLabel } from "../lib/i18n";
import { Trophy, MapPin, Calendar, CurrencyDollar } from "@phosphor-icons/react";

export default function Tournaments() {
  const [tournaments, setTournaments] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/tournaments").then((r) => setTournaments(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "all" ? tournaments : tournaments.filter((x) => x.status === filter);

  const filters = [
    { id: "all", label: t.filterAll },
    { id: "upcoming", label: t.statusUpcoming },
    { id: "live", label: t.statusLive },
    { id: "completed", label: t.statusCompleted },
  ];

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="flex items-end justify-between border-b border-white/10 pb-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FF0055] font-mono">
            // {t.sectionCircuit}
          </div>
          <h1 className="font-display font-black uppercase italic text-5xl sm:text-6xl mt-2">
            {t.tournamentsTitle}
          </h1>
        </div>
        <Trophy size={48} weight="fill" className="text-[#FF0055]/40 hidden md:block" />
      </div>

      <div className="flex gap-2 mt-8 flex-wrap" data-testid="tournament-filters">
        {filters.map((f) => (
          <button
            key={f.id}
            data-testid={`filter-${f.id}`}
            onClick={() => setFilter(f.id)}
            className={`px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] border transition-colors ${
              filter === f.id
                ? "border-[#FF0055] bg-[#FF0055]/10 text-[#FF0055]"
                : "border-white/15 text-white/60 hover:text-white"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        {filtered.map((tt) => (
          <Link
            key={tt.id}
            to={`/tournaments/${tt.id}`}
            data-testid={`tournament-card-${tt.id}`}
            className="group relative block overflow-hidden border border-white/10 hover:border-[#FF0055]/60 transition-colors bg-[#0C0C14]"
          >
            <div
              className="aspect-[16/10] bg-cover bg-center"
              style={{ backgroundImage: `url('${tt.banner_url}')` }}
            />
            <div className="absolute top-3 left-3 flex items-center gap-2">
              <span
                className={`text-[10px] uppercase tracking-[0.2em] font-bold px-2 py-1 ${
                  tt.status === "live"
                    ? "bg-[#FF0055] text-white"
                    : tt.status === "upcoming"
                    ? "border border-[#00E5FF] text-[#00E5FF] bg-[#05050A]/80"
                    : "border border-white/30 text-white/60 bg-[#05050A]/80"
                }`}
              >
                {statusLabel(tt.status)}
              </span>
              {tt.created_by === "community" && (
                <span className="text-[10px] uppercase tracking-[0.2em] font-bold px-2 py-1 bg-[#E2FF00]/15 text-[#E2FF00] border border-[#E2FF00]/40">
                  {t.community}
                </span>
              )}
            </div>
            <div className="p-5 border-t border-white/10">
              <div className="font-display font-black uppercase italic text-2xl group-hover:text-[#00E5FF] transition-colors">
                {tt.name}
              </div>
              <div className="mt-3 space-y-1.5 text-xs text-white/60 font-mono">
                <div className="flex items-center gap-2"><MapPin size={12} /> {tt.location}</div>
                <div className="flex items-center gap-2"><Calendar size={12} /> {new Date(tt.start_date).toLocaleDateString("pl-PL")}</div>
                <div className="flex items-center gap-2 text-[#E2FF00]"><CurrencyDollar size={12} /> {tt.prize_pool}</div>
                <div className="text-white/40">{tt.format === "group_knockout" ? t.formatGroupKnockout : t.formatSingleElim}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="text-center text-white/40 py-20 font-mono text-sm">
          {t.noTournamentsCategory}
        </div>
      )}
    </div>
  );
}
